import * as React from "react";
const FavoriteFilled = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.5 4 9.729 9.069 4 10.112 8.015 14.287 7.248 19.999 12.5 17.512 17.753 20 16.986 14.287 21.001 10.112 15.272 9.069z" }));
FavoriteFilled.displayName = "FavoriteFilled";
var FavoriteFilled_default = FavoriteFilled;
export {
  FavoriteFilled_default as default
};
